import React, { useRef } from 'react';
import { Camera, Image as ImageIcon } from 'lucide-react';

/**
 * Gallery + Camera image picker.
 * Calls onChange with { target: { files } } so existing file handlers keep working.
 */
const ImageSourcePicker = ({
  onChange,
  accept = 'image/*',
  multiple = false,
  disabled = false,
  galleryLabel = 'Gallery',
  cameraLabel = 'Camera',
  hint = null,
  style = {}
}) => {
  const galleryRef = useRef(null);
  const cameraRef = useRef(null);

  const emitFiles = (fileList) => {
    if (!onChange || !fileList || fileList.length === 0) return;
    const files = Array.from(fileList);
    onChange({ target: { files } });
  };

  const handleGalleryChange = (e) => {
    emitFiles(e.target.files);
    e.target.value = '';
  };

  const handleCameraChange = (e) => {
    emitFiles(e.target.files);
    e.target.value = '';
  };

  return (
    <div style={{ width: '100%', ...style }}>
      <div
        style={{
          display: 'flex',
          gap: '0.5rem',
          flexWrap: 'wrap',
          justifyContent: 'center'
        }}
      >
        <button
          type="button"
          className="btn btn-outline"
          disabled={disabled}
          onClick={() => galleryRef.current?.click()}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.4rem',
            padding: '0.5rem 0.85rem',
            fontSize: '0.875rem'
          }}
        >
          <ImageIcon size={16} />
          {galleryLabel}
        </button>
        <button
          type="button"
          className="btn btn-outline"
          disabled={disabled}
          onClick={() => cameraRef.current?.click()}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.4rem',
            padding: '0.5rem 0.85rem',
            fontSize: '0.875rem'
          }}
        >
          <Camera size={16} />
          {cameraLabel}
        </button>
      </div>
      {hint && (
        <div style={{ color: 'var(--text-secondary)', fontSize: '0.75rem', marginTop: '0.5rem', textAlign: 'center' }}>
          {hint}
        </div>
      )}
      <input
        ref={galleryRef}
        type="file"
        accept={accept}
        multiple={multiple}
        onChange={handleGalleryChange}
        disabled={disabled}
        style={{ display: 'none' }}
      />
      <input
        ref={cameraRef}
        type="file"
        accept={accept}
        capture="environment"
        onChange={handleCameraChange}
        disabled={disabled}
        style={{ display: 'none' }}
      />
    </div>
  );
};

export default ImageSourcePicker;
